<mat-card class="example-card">
    <mat-card-header class="titreFrm">
        <mat-card-title>{{'Planning Global'.toUpperCase()}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
        <!-- ------------------------------Ente du recherche-------------------------------------- -->
        <div>
            <div class="btn">
                <button mat-raised-button color="primary" class="button" (click)="switchMode()"><mat-icon>autorenew</mat-icon>Switch Salarié / Action</button>
                <button mat-raised-button class="colorGreen button"  (click)="setTable()"><mat-icon>search</mat-icon>Afficher</button>
            </div>
            <div class="displayFlex">
                <mat-card >
                    <h4>Plage horaire</h4>
                        <mat-form-field     appearance="outline"  style="margin-right:15px;width: 130px; ">
                            <mat-label>Du</mat-label>
                            <input (dateChange)="dateChange()" matInput [matDatepicker]="dateDebut" placeholder="Du" [(ngModel)]="date_Debut">
                            <mat-datepicker-toggle matSuffix [for]="dateDebut"></mat-datepicker-toggle>
                            <mat-datepicker #dateDebut></mat-datepicker>
                        </mat-form-field>
                        <br>
                        <mat-form-field     appearance="outline"  style="width: 130px; ">
                            <mat-label>Au</mat-label>
                            <input (dateChange)="dateChange()" matInput [matDatepicker]="dateFin" placeholder="Au" [(ngModel)]="date_Fin">
                            <mat-datepicker-toggle matSuffix [for]="dateFin"></mat-datepicker-toggle>
                            <mat-datepicker #dateFin></mat-datepicker>
                        </mat-form-field>
                </mat-card>
                <mat-card [ngClass]="param == 'mon_planning' ? 'display-none' : ''">
                    <h4>Collaborateurs</h4>
                    <button (click)="selectAllCollaboteur()" mat-button><mat-icon>done_all</mat-icon>&nbsp;Tout sélectionner</button>
                    <button (click)="deSelectAllCollaboteur()" mat-button><mat-icon>close</mat-icon>&nbsp;Annuler</button>
                    <div style="border: 1px solid rgb(226, 224, 230)!important">
                        <mat-selection-list #personnelsSelected style="height: 150px; overflow-y: scroll" (selectionChange)="onSelectionPersonnel(personnelsSelected.selectedOptions.selected)" >
                            <mat-list-option *ngFor="let personnel of personnelTab" [value]="personnel.Perso_Matricule">
                                {{personnel.Perso_Nom + " " + personnel.Perso_Prenom}}
                            </mat-list-option>
                        </mat-selection-list>
                    </div>
                </mat-card>
                <mat-card >
                    <h4>Actions</h4>
                    <button (click)="selectAllAction()" mat-button><mat-icon>done_all</mat-icon>&nbsp;Tout sélectionner</button>
                    <button (click)="deSelectAllAction()" mat-button><mat-icon>close</mat-icon>&nbsp;Annuler</button>
                    <div style="border: 1px solid rgb(226, 224, 230)!important">
                        <mat-selection-list #actionsSelected style="height: 150px; overflow-y: scroll" (selectionChange)="onSelectionAction(actionsSelected.selectedOptions.selected)">
                            <!-- [matTooltip]="action.avtAction_dateDeb.substring(0,10) +' -> ' + action.avtAction_dateFin.substring(0,10)" -->
                            <mat-list-option 
                                *ngFor="let action of actionTab" 
                                [value]="action.avtAction_Code">
                                {{action.avtAction_Intitule}}
                            </mat-list-option>
                        </mat-selection-list>
                    </div>  
                </mat-card>

                <mat-card >
                    <h4>Type Actions</h4>
                    <button (click)="selectAllTypeAction()" mat-button><mat-icon>done_all</mat-icon>&nbsp;Tout sélectionner</button>
                    <button (click)="deSelectAllTypeAction()" mat-button><mat-icon>close</mat-icon>&nbsp;Annuler</button>
                    <div style="border: 1px solid rgb(226, 224, 230)!important">
                        <mat-selection-list #typeActionSelected style="height: 150px; overflow-y: scroll" (selectionChange)="onSelectionTypeAction(typeActionSelected.selectedOptions.selected)">
                            <mat-list-option 
                                *ngFor="let type of typeActionTab" 
                                [value]="type.avtParamAction_Code">
                                {{type.avtParamAction_Description}}
                            </mat-list-option>
                        </mat-selection-list>
                    </div>  
                </mat-card>
            </div>

            <!-- --------------------------contenue du tableau------------------------------- -->

            <div fxLayout="column" fxLayoutAlign="begin center" class="content">
                <div *ngIf="test" style="width: 100%; overflow-x: scroll">
                    <br>
                    <table>
                        <tr class="background0">
                            <td [attr.rowspan]="3+1">{{val1}}</td>
                            <td [attr.rowspan]="3+1"> Total</td>
                            <td style="color: blue;" *ngFor="let myMonth of selectedMonthsTab" [attr.colspan]="myMonth.colSpan">{{myMonth.monthName+" "+myMonth.year}}</td>
                        </tr>
                        <tr class="background0">
                            <td style="color: rgb(5, 151, 17);" *ngFor="let myWeek of selectedWeekTab" [attr.colspan]="myWeek.colSpan">{{myWeek.monthName}}</td>
                        </tr>
                        <tr class="background0">
                            <td  *ngFor="let myDay of daysSelected">{{myDay}}</td>
                        </tr>
                        <tr class="background0">
                            <td *ngFor="let myDay2 of daysSelected2">{{myDay2}}</td>
                        </tr>
                        
                        <tr *ngFor="let mycol of tableContentPersonnel">
                            <td *ngFor="let myRow of mycol;let i = index" [ngClass]="'background'+i" >
                                <p [style.background-color]="myRow.color" style="min-width: 20px;
                                color: rgb(73, 68, 68);
                                text-align: center;
                                font-size: 0.80em;">
                                    {{myRow.content}}</p>
                            </td>
                        </tr>
                        <tr class="background0">
                            <td>
                                {{val2}}
                            </td>
                            <td [attr.colspan]="numberDay +1"></td>
                        </tr>
                        <tr *ngFor="let mycol of tableContentAction;let i = index" [ngClass]="'background'+i">
                            <td *ngFor="let myRow of mycol;let j = index" [ngClass]="'background'+j">
                                <p [style.background-color]="myRow.color" style="min-width: 20px;
                                  background: white;
                                color: rgb(73, 68, 68);
                                text-align: center;
                                font-size: 0.80em;">
                                    {{myRow.content}}</p>
                            </td>
                        </tr>

                    </table>
                   
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>
<div *ngIf="hideProgress;else attente"></div>
 <ng-template #attente>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</ng-template>